import { concat, pad } from "viem";
import { formatSignatures } from "./formatSignatures.js";
export const combineSignatures = ({ signatures, upperLimitMaxFeePerGas, upperLimitMaxPriorityFeePerGas, upperLimitPvg, }) => {
    return concat([
        pad(upperLimitPvg),
        pad(upperLimitMaxFeePerGas),
        pad(upperLimitMaxPriorityFeePerGas),
        formatSignatures(signatures),
    ]);
};
//# sourceMappingURL=combineSignatures.js.map